import EventBus from '../../utils/EventBus';
import Responsive from '../../utils/Responsive';

export default {
    props: {
        config: {},
        linkedBreakpoint: {
            required: false,
            type: String,
            default: 'm'
        },
        threshold: {
            required: false,
            type: Number,
            default: 100
        },
        maxHeight: {
            required: false,
            type: Number,
            default: 280
        },
        maxHeightLinked: {
            required: false,
            type: Number,
            default: 220
        }
    },
    data() {
        return {
            enabled: true
        }
    },
    computed: {
        classList() {
            return {
                'is-expandable': this.enabled
            }
        }
    },
    components: {
        // Bare component to use when native HTML element is used as child.
        // This way we can set the ref="" attribute to create references to
        // the needed DOM elements.
        'sdw-expander-child': {}
    },
    created() {
        EventBus.$on('Responsive:onResize', () => {
            this.equalHeight();
        });
    },
    methods: {
        equalHeight() {
            // Quit if we don't have both yet
            if (!this.sourceEl || !this.targetEl) {
                return;
            }

            if(!Responsive.isInsideBreakpoint(this.linkedBreakpoint)) {

                let targetIsSmaller = this.sourceEl.offsetHeight >= this.targetEl.scrollHeight;
                let heightDifferenceIsWithinThreshold = (this.targetEl.scrollHeight - this.sourceEl.offsetHeight) <= this.threshold;
                let fitsInMaximumHeight = this.targetEl.scrollHeight < (this.maxHeightLinked + this.threshold);

                if (targetIsSmaller || heightDifferenceIsWithinThreshold || fitsInMaximumHeight) {
                    this.enabled = false;
                    this.resetHeight();
                } else {
                    this.enabled = true;
                    this.setHeight(Math.max(this.sourceEl.offsetHeight, this.maxHeightLinked));
                }
            } else {
                let fitsInMaximumHeight = this.targetEl.scrollHeight < (this.maxHeight + this.threshold);
                if (fitsInMaximumHeight) {
                    this.enabled = false;
                    this.resetHeight();
                } else {
                    this.enabled = true;
                    this.setHeight(this.maxHeight);
                }
            }
        },
        setHeight(height) {
            this.targetEl.style.maxHeight = height + 'px';
        },
        resetHeight() {
            // Empty string removes the property
            this.targetEl.style.maxHeight = '';
        },
        registerExpanderSource(component) {
            this.sourceComponent = component;
            this.sourceEl = this.sourceComponent.$refs.expanderSourceEl;

            this.equalHeight();
        },
        registerExpanderTarget(component) {
            this.targetComponent =  component;
            this.targetEl = this.targetComponent.$refs.expanderTargetEl;

            this.equalHeight();
        }
    }
};
